import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames/bind';
import Heading from 'components/shared/heading';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Card from './card';
import LogoIcon from './svg/logo.inline.svg';

import shape from './svg/shape.svg';

import styles from './home-solutions.module.scss';

const cx = classNames.bind(styles);

const HomeSolutions = ({ title, description, items }) => {
  const { illustration } = useStaticQuery(graphql`
    query {
      illustration: file(relativePath: { eq: "home/easy-to-use/illustration.png" }) {
        childImageSharp {
          gatsbyImageData(width: 640)
        }
      }
    }
  `);

  const containerAnimationVariants = {
    initial: {},
    appear: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4,
      },
    },
  };
  const [sectionRef, inView] = useInView({ threshold: 0.3, triggerOnce: true });

  return (
    <section ref={sectionRef} className={cx('wrapper')}>
      <div className="container">
        <div className="columns">
          <div className={cx('column is-12-mobile is-6-tablet is-7-widescreen', 'left')}>
            <Heading className={cx('title')} tag="h2" size="xl" color="tertiary">
              {title}
            </Heading>
            <p className={cx('description')}>{description}</p>
          </div>

          <motion.div
            variants={containerAnimationVariants}
            className="column is-12-mobile is-6-tablet is-5-widescreen"
            animate={inView ? 'appear' : 'initial'}
          >
            {items.map((item, index) => (
              <Card className={cx('card')} {...item} key={index} />
            ))}
          </motion.div>
        </div>

        <div className={cx('illustration-wrapper')}>
          <GatsbyImage className={cx('illustration')} image={getImage(illustration)} alt="" />
          <LogoIcon className={cx('logo')} />
        </div>

        <img className={cx('shape')} src={shape} alt="" />
      </div>
    </section>
  );
};

HomeSolutions.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default HomeSolutions;
